var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ring-loader',{class:_vm.current ? '' : `tw-text-${_vm.color}`,attrs:{"size":_vm.size,"color":"currentColor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }